// extracted by mini-css-extract-plugin
module.exports = {"button":"e_J7","inner":"e_K7","innerText":"e_L7"};